export default __webpack_public_path__ + "img/djeno.4d956ddd.jpg";